import { IResource } from "../i18n";

const translation_pl: IResource = {
    header_title: 'MEET | Spotkania bez napięcia',
    header_menu_api: 'API',
    header_signup_text: 'Zarejestruj się za darmo',
    header_signin_text: 'Zaloguj się',
    header_dashboard_text: 'Moja deska rozdzielcza',

    general_title_text: 'Wywiady bez tarcia',
    general_cta_text_one: 'Oszczędzaj czas, pieniądze i nerwy',
    general_cta_text_two: 'przy organizowaniu i prowadzeniu',
    general_cta_text_three: 'zdalne rozmowy o pracę',
    general_cta_button: 'Spróbuj teraz za darmo',
    general_cta_contact: 'Skontaktuj się z nami: office@meet.rs',
    general_cta_consent_one: 'Ta strona używa plików cookie tylko do celów analitycznych i personalizacji.',
    general_cta_consent_two: 'Kontynuując korzystanie z tej strony, użytkownik zgadza się z ',
    general_tos_text: 'Warunki użytkowania',
    general_tos_tooltip: 'Poznaj regulamin Vivani Meet',
    general_cookies_text: 'Polityka Cooki',
    general_cookies_tooltip: 'Polityka Vivani Ciasteczka Meet',
    general_privacy_text: 'Polityka prywatności',
    general_privacy_tooltip: 'Vivani Meet Polityka prywatności',
    general_refund_text: 'Polityka w zakresie refinansowania',
    general_refund_tooltip: 'Polityka Vivani Meet zwrotów',

    usecase_title_head: 'Zbudowany na zamówienie do przeprowadzania wywiadów zdalnych',
    usecase_title_subhead: 'Wszystko zostało zaprojektowane w oparciu o potrzeby rekruterskie zdalnych rozmów kwalifikacyjnych, które rekruterzy i ankieterzy mają dzisiaj',
    usecase_interviewer_title: 'PRZYJAZNY ANKIETER',
    usecase_interviewer_subtitle: 'Biblioteka zadań',
    usecase_interviewer_body: 'Ustalić zadania związane z wywiadem z góry i cieszyć się wywiadem',
    usecase_interviewer_learnmore: 'Dowiedz się więcej ',
    usecase_interviewer_imgalt: 'Wywiad z dostępem Tablicy',
    usecase_collaboration_title: 'RAZEM PRACA',
    usecase_collaboration_subtitle: 'Zbudowany do współpracy',
    usecase_collaboration_body_one: 'Wywoływanie, kodowanie, rysowanie, pisanie...',
    usecase_collaboration_body_two: 'Wszystko razem, wszystko w tym samym czasie.',
    usecase_collaboration_learnmore: 'Dowiedz się więcej  ',
    usecase_collaboration_imgalt: 'Wywiad z dostępem Tablicy',    
    usecase_recruiter_title: 'PRZYJAZNY REKRUTER',
    usecase_recruiter_subtitle: 'Robiąc twoją pracę dla ciebie',
    usecase_recruiter_body: 'Automatyczne planowanie, sporządzanie notatek, przypomnień dla uczestników, zbieranie informacji zwrotnych...',
    usecase_recruiter_learnmore: 'Dowiedz się więcej ',
    usecase_recruiter_imgalt: 'Wywiad z dostępem Tablicy',    
    usecase_call_title: 'ROZMOWA WIDEO W PEŁNEJ GRUPIE HD',
    usecase_call_subtitle: 'Z nagrywaniem i transkrypcją',
    usecase_call_body_one: 'Zero wtyczek, aplikacji, instalacji',
    usecase_call_body_two: 'To po prostu działa na nowoczesnych przeglądarkach!',
    usecase_call_learnmore: 'Dowiedz się więcej',
    usecase_call_imgalt: 'Wywiad z dostępem Tablicy',     

    footer_email_text: "Skontaktuj się z nami",

    signout_menu_text: "Wyloguj się",
    me_menu_text: "Mój Meet",

    help_menu_text: "Pomoc",

    cta_nosignup_text: "Nie jest wymagana rejestracja ani pobieranie.",
    
    // Change language
    language_selector_title: "Language",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "Zorganizuj spotkanie",
    general_cta_text_all: "Oszczędzaj czas, pieniądze i nerwy przy organizowaniu i prowadzeniu zdalne rozmowy o pracę",

    header_title_short: "Vivani Meet",

}

export default translation_pl;